import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import {
  boardSettingsGetAllData,
  swapStageOrder,
} from '../actions/boardSettings';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export function fetchAllData() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/dashboard/details`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(boardSettingsGetAllData(json));
          }
        })
    }
  }
}

export function toggleStages(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardStage/toggleStages`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json && json.updated === true) {
              fetchAllData()(dispatch);
              dispatch(notify({
                title: 'Toggle',
                message: 'Stages was successfully toggled',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
            dispatch(swapStageOrder({ swapStage: json }));
          }
        })
    }
  }
}

export function reOrderStages(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardStage/swapStagesOrder`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json && json.updated === true) {
              fetchAllData()(dispatch);
              dispatch(notify({
                title: 'Reorder',
                message: 'Stages was successfully reordered',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
            dispatch(swapStageOrder({ swapStage: json }));
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/boardSettings.js